import React from "react";

const defaultEmissionsByTypeERO = [
  { typeLabelERO: "Transition risks", amountMetricTonnesERO: "" },
  { typeLabelERO: "Physical risks", amountMetricTonnesERO: "" },
  { typeLabelERO: "Climate-related opportunities", amountMetricTonnesERO: "" },
];

const EmissionsByTypeRiskOppTable = ({
  emissionsByTypeERO,
  setEmissionsByTypeERO,
}) => {
  const handleChange = (i, field, value) => {
    const updated = [...emissionsByTypeERO];
    updated[i][field] = value;
    setEmissionsByTypeERO(updated);
  };

  // remove inline borders; CSS below draws inner grid + hides outer edges
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };
  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };
  const leftLabelCell = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: 600,
  };
  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid gray",
    borderRadius: "6px",
    fontSize: "14px",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        borderRadius: 12,
        overflow: "hidden",
        border: "1px solid #000", // outer frame for perfect rounded corners
      }}
    >
      {/* Inner grid + hide table outer edges so corners align perfectly */}
      <style>{`
        .eroTable{
          width: 100%;
          border-collapse: collapse;
        }
        .eroTable th,
        .eroTable td{
          border: 1px solid #000;
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .eroTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide outer edges (wrapper's border draws them) */
        .eroTable thead tr:first-child th{ border-top: 0; }
        .eroTable tr th:first-child,
        .eroTable tr td:first-child{ border-left: 0; }
        .eroTable tr th:last-child,
        .eroTable tr td:last-child{ border-right: 0; }
        .eroTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <table className="eroTable">
        <thead>
          <tr>
            <th style={header}>Risk / Opportunity category</th>
            <th style={header}>Percentage of assets / activities</th>
          </tr>
        </thead>

        <tbody>
          {emissionsByTypeERO.map((row, idx) => (
            <tr key={idx}>
              <td style={leftLabelCell}>{row.typeLabelERO}</td>
              <td style={cell}>
                <input
                  style={inputStyle}
                  placeholder="Enter data"
                  value={row.amountMetricTonnesERO}
                  onChange={(e) =>
                    handleChange(idx, "amountMetricTonnesERO", e.target.value)
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EmissionsByTypeRiskOppTable;
